import React, { useEffect } from "react";
import { useState } from "react";
import {
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
} from "@mui/icons-material";
import {
  Button,
  Card,
  Collapse,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminFarmerDetail() {
  // Navigate
  const navigate = useNavigate();
  const id = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const farmer = useSelector((state) => state.farmer.data);
  const workingArea = useSelector((state) => state.workingArea.data);
  const bank = useSelector((state) => state.bank.data);
  const priceType = useSelector((state) => state.priceType.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerCode: "",
    ktpNumber: "",
    fullName: "",
    phoneNumber: "",
    address: "",
    workingAreaId: "",
    bankId: "",
    accountNumber: "",
    accountName: "",
    priceTypeId: "",
  });
  const [certificates, setCertificates] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [cardsSetting, setCardsSetting] = useState({
    informasiPribadi: true,
    dataSertifikat: true,
    dataBank: true,
  });

  // Column
  const certificatesColumn = ["Nama Sertifikat", "Tahun", "Deskripsi"];

  useEffect(() => {
    if (fetch) {
      const x = farmer.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setCertificates([...farmer.docs[x].certificate]);
        setFormData({
          farmerCode: farmer.docs[x].farmerCode
            ? farmer.docs[x].farmerCode
            : "",
          ktpNumber: farmer.docs[x].ktpNumber ? farmer.docs[x].ktpNumber : "",
          fullName: farmer.docs[x].fullName ? farmer.docs[x].fullName : "",
          phoneNumber: farmer.docs[x].phoneNumber
            ? farmer.docs[x].phoneNumber
            : "",
          address: farmer.docs[x].address ? farmer.docs[x].address : "",
          workingAreaId: farmer.docs[x].workingAreaId
            ? farmer.docs[x].workingAreaId._id
            : "",
          workingAreaName: farmer.docs[x].workingAreaId
            ? farmer.docs[x].workingAreaId.areaName
            : "",
          priceTypeId: farmer.docs[x].priceTypeId
            ? farmer.docs[x].priceTypeId._id
            : "",
          priceTypeName: farmer.docs[x].priceTypeId
            ? farmer.docs[x].priceTypeId.typeName
            : "",
          bankId: farmer.docs[x].bankAccount
            ? farmer.docs[x].bankAccount.bankId?._id
            : "",
          bankName: farmer.docs[x].bankAccount
            ? farmer.docs[x].bankAccount.bankId?.bankName
            : "",
          accountNumber: farmer.docs[x].bankAccount
            ? farmer.docs[x].bankAccount.accountNumber
            : "",
          accountName: farmer.docs[x].bankAccount
            ? farmer.docs[x].bankAccount.accountName
            : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  const handleCollapse = (val) => {
    switch (val) {
      case 1:
        setCardsSetting({
          ...cardsSetting,
          informasiPribadi: !cardsSetting.informasiPribadi,
        });
        break;
      case 2:
        setCardsSetting({
          ...cardsSetting,
          dataSertifikat: !cardsSetting.dataSertifikat,
        });
        break;
      case 3:
        setCardsSetting({ ...cardsSetting, dataBank: !cardsSetting.dataBank });
        break;
      default:
        break;
    }
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              INFORMASI PRIBADI
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.informasiPribadi ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(1)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />

        <Collapse style={{ width: "100%" }} in={cardsSetting.informasiPribadi}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                margin: "10px 0px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                KODE PETANI
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  maxLength: 20,
                  style: { background: "white" },
                  readOnly: true,
                }}
                required
                helperText={
                  formData.farmerCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.farmerCode)
                      ? ""
                      : "*Format Kode Petani salah"
                    : ""
                }
                size="small"
                error={
                  formData.farmerCode.length > 0
                    ? /^[A-Za-z]{3}-\d{5}/.test(formData.farmerCode)
                      ? false
                      : true
                    : false
                }
                name="farmerCode"
                value={formData.farmerCode}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
                background: "none",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO KTP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.ktpNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.ktpNumber)
                    ? ""
                    : "*Formart No KTP salah"
                }
                inputProps={{
                  maxLength: 16,
                  style: { background: "white" },
                  readOnly: true,
                }}
                name="ktpNumber"
                value={formData.ktpNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA LENGKAP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 50, readOnly: true }}
                required
                size="small"
                error={false}
                name="fullName"
                value={formData.fullName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO TELP
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  maxLength: 20,
                  style: { background: "white" },
                  readOnly: true,
                }}
                required
                type="tel"
                size="small"
                error={/^[0-9]*$/.test(formData.phoneNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.phoneNumber)
                    ? ""
                    : "*Formart No Telepon salah"
                }
                name="phoneNumber"
                value={formData.phoneNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                marginBottom: "10px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                ALAMAT
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 250 }}
                error={false}
                name="address"
                value={formData.address}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>

            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                AREA
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  readOnly: true,
                }}
                select
                required
                size="small"
                error={false}
                name="workingAreaId"
                value={formData.workingAreaId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.workingAreaName &&
                formData.workingAreaId.length > 0 ? (
                  <MenuItem value={formData.workingAreaId}>
                    {formData.workingAreaName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Area Kerja Karyawan</MenuItem>
                )}
                {workingArea.docs.length > 0 ? (
                  workingArea.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.areaName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>

            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                TIPE HARGA
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  readOnly: true,
                }}
                select
                required
                size="small"
                error={false}
                name="priceTypeId"
                value={formData.priceTypeId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.priceTypeName && formData.priceTypeId.length > 0 ? (
                  <MenuItem value={formData.priceTypeId}>
                    {formData.priceTypeName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Tipe Harga</MenuItem>
                )}
                {priceType.docs.length > 0 ? (
                  priceType.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.typeName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA SERTIFIKAT
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataSertifikat ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(2)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataSertifikat}>
          <form style={{ width: "100%" }}>
            <Typography marginTop={1}>Data Sertifikat :</Typography>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "10px",
              }}
            >
              <thead>
                {certificatesColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {certificates.length > 0 &&
                  certificates.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              name="certificateName"
                              inputProps={{ maxLength: 50, readOnly: true }}
                              id={index}
                              value={item.certificateName}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 25, readOnly: true }}
                              type="number"
                              error={false}
                              name="certificateYear"
                              id={index}
                              value={item.certificateYear}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 25, readOnly: true }}
                              error={false}
                              name="certificateDescription"
                              id={index}
                              value={item.certificateDescription}
                              variant="outlined"
                              fullWidth
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </form>
        </Collapse>
      </Card>
      <Card className={styles.headerClass}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          minWidth={"100%"}
        >
          <Grid items>
            <Typography fontSize={16} color={"#2D6B56"} variant="h6">
              DATA BANK
            </Typography>
          </Grid>
          <Grid
            items
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50px",
              background: "#386e5b",
              color: "white",
            }}
          >
            {!cardsSetting.dataBank ? (
              <KeyboardArrowDownRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            ) : (
              <KeyboardArrowUpRounded
                style={{ cursor: "pointer" }}
                onClick={() => handleCollapse(3)}
              />
            )}
          </Grid>
        </Grid>
        <Divider className={styles.dividerStyle} />
        <Collapse style={{ width: "100%" }} in={cardsSetting.dataBank}>
          <form
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                PILIH BANK
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  readOnly: true,
                }}
                required
                select
                size="small"
                error={false}
                name="bankId"
                value={formData.bankId}
                fullWidth
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.bankName && formData.bankId.length > 0 ? (
                  <MenuItem value={formData.bankId}>
                    {formData.bankName}
                  </MenuItem>
                ) : (
                  <MenuItem value="">Pilih Area Kerja Karyawan</MenuItem>
                )}
                {bank.docs.length > 0 ? (
                  bank.docs.map((data, index) => (
                    <MenuItem value={data._id} key={index}>
                      {data.bankName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NO REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ style: { background: "white" }, readOnly: true }}
                required
                size="small"
                error={/^[0-9]*$/.test(formData.accountNumber) ? false : true}
                helperText={
                  /^[0-9]*$/.test(formData.accountNumber)
                    ? ""
                    : "*No Rekening tidak valid"
                }
                name="accountNumber"
                value={formData.accountNumber}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <FormControl
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "flex-start",
                width: "100%",
                marginBottom: "10px",
                flexDirection: "row",
              }}
            >
              <Typography
                fontSize={14}
                color={"#2e473f"}
                variant="h6"
                width="16%"
              >
                NAMA REKENING
              </Typography>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                size="small"
                inputProps={{ maxLength: 50, readOnly: true }}
                error={false}
                name="accountName"
                value={formData.accountName}
                fullWidth
                variant="outlined"
                style={{
                  maxWidth: "400px",
                  background: "white",
                  marginRight: "10px",
                }}
              />
            </FormControl>
            <div className={styles.footerButton}>
              <Button
                variant="contained"
                color="error"
                style={{ marginLeft: "10px" }}
                onClick={() => navigate("/admin/petani")}
              >
                KEMBALI
              </Button>
            </div>
          </form>
        </Collapse>
      </Card>
    </Grid>
  );
}
